const isObjEmpty = (obj) => {
  if (!obj) {
    return false;
  }
  return Object.keys(obj).length === 0;
};

export default isObjEmpty;
